import React from 'react';
import Box from "@mui/material/Box";
import {Button} from "@mui/material";

const PrevAndNextComponent = ({steps, activeStep, handleBack, handleLocalNext}) => {
    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Box sx={{ mb: 2 }}>
                <div>
                    <Button
                        variant="outlined"
                        size="large"
                        color="secondary"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mt: 1, mr: 4 }}
                        style={{borderRadius: "100px"}}
                    >
                        Previous
                    </Button>

                    <Button
                        variant="outlined"
                        color="success"
                        size="large"
                        onClick={handleLocalNext}
                        sx={{ mt: 1, ml: 4 }}
                        style={{borderRadius: "100px"}}
                    >
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </Box>
        </div>
    )
};

export default PrevAndNextComponent;